function cov_vwwk9nd8u() {
  var path = "/app/src/components/snippet-default/snippet-default.tsx";
  var hash = "3e9567a896afaabd838c10142a13876109317fc2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/snippet-default/snippet-default.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 31
        },
        end: {
          line: 12,
          column: 33
        }
      },
      "1": {
        start: {
          line: 22,
          column: 30
        },
        end: {
          line: 90,
          column: 1
        }
      },
      "2": {
        start: {
          line: 29,
          column: 54
        },
        end: {
          line: 29,
          column: 69
        }
      },
      "3": {
        start: {
          line: 30,
          column: 22
        },
        end: {
          line: 30,
          column: 38
        }
      },
      "4": {
        start: {
          line: 31,
          column: 21
        },
        end: {
          line: 31,
          column: 43
        }
      },
      "5": {
        start: {
          line: 32,
          column: 40
        },
        end: {
          line: 32,
          column: 55
        }
      },
      "6": {
        start: {
          line: 33,
          column: 21
        },
        end: {
          line: 33,
          column: 56
        }
      },
      "7": {
        start: {
          line: 34,
          column: 27
        },
        end: {
          line: 34,
          column: 78
        }
      },
      "8": {
        start: {
          line: 36,
          column: 29
        },
        end: {
          line: 40,
          column: 3
        }
      },
      "9": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 39,
          column: 5
        }
      },
      "10": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 16
        }
      },
      "11": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 47,
          column: 28
        }
      },
      "12": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "13": {
        start: {
          line: 44,
          column: 28
        },
        end: {
          line: 44,
          column: 59
        }
      },
      "14": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 61
        }
      },
      "15": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 89,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 30
          },
          end: {
            line: 22,
            column: 31
          }
        },
        loc: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 36,
            column: 29
          },
          end: {
            line: 36,
            column: 30
          }
        },
        loc: {
          start: {
            line: 36,
            column: 35
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 36
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 42,
            column: 13
          }
        },
        loc: {
          start: {
            line: 42,
            column: 18
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 42
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 39,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 39,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 16
          }
        }, {
          start: {
            line: 43,
            column: 20
          },
          end: {
            line: 43,
            column: 38
          }
        }],
        line: 43
      },
      "3": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 18
          }
        }, {
          start: {
            line: 54,
            column: 22
          },
          end: {
            line: 54,
            column: 53
          }
        }],
        line: 54
      },
      "4": {
        loc: {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 55,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 26
          },
          end: {
            line: 55,
            column: 30
          }
        }, {
          start: {
            line: 55,
            column: 33
          },
          end: {
            line: 55,
            column: 61
          }
        }],
        line: 55
      },
      "5": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 25
          }
        }, {
          start: {
            line: 56,
            column: 29
          },
          end: {
            line: 56,
            column: 58
          }
        }],
        line: 56
      },
      "6": {
        loc: {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 17
          }
        }, {
          start: {
            line: 62,
            column: 21
          },
          end: {
            line: 62,
            column: 35
          }
        }],
        line: 62
      },
      "7": {
        loc: {
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 63,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 63,
            column: 20
          }
        }, {
          start: {
            line: 63,
            column: 24
          },
          end: {
            line: 63,
            column: 55
          }
        }],
        line: 63
      },
      "8": {
        loc: {
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 22
          }
        }, {
          start: {
            line: 64,
            column: 26
          },
          end: {
            line: 64,
            column: 43
          }
        }, {
          start: {
            line: 64,
            column: 47
          },
          end: {
            line: 64,
            column: 64
          }
        }],
        line: 64
      },
      "9": {
        loc: {
          start: {
            line: 67,
            column: 9
          },
          end: {
            line: 76,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 22
          }
        }, {
          start: {
            line: 70,
            column: 10
          },
          end: {
            line: 75,
            column: 12
          }
        }],
        line: 67
      },
      "10": {
        loc: {
          start: {
            line: 80,
            column: 17
          },
          end: {
            line: 80,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 36
          },
          end: {
            line: 80,
            column: 45
          }
        }, {
          start: {
            line: 80,
            column: 48
          },
          end: {
            line: 80,
            column: 64
          }
        }],
        line: 80
      },
      "11": {
        loc: {
          start: {
            line: 83,
            column: 7
          },
          end: {
            line: 87,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 7
          },
          end: {
            line: 83,
            column: 15
          }
        }, {
          start: {
            line: 83,
            column: 19
          },
          end: {
            line: 83,
            column: 36
          }
        }, {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 14
          }
        }],
        line: 83
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3e9567a896afaabd838c10142a13876109317fc2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_vwwk9nd8u = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_vwwk9nd8u();
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import cn from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Logo } from 'src/components/logo';
import { SnippetContent } from 'src/components/snippet-content';
import { Skeleton } from 'src/components/snippet-default/components/skeleton';
import { SnippetWrapper } from 'src/components/snippet-wrapper';
import { useAppContext } from 'src/context/store/app-provider';
import { useStyleConfig } from 'src/hooks/use-style-config';
import styles from './styles.css';
var SINGLE_LINE_MAX_HEIGHT = (cov_vwwk9nd8u().s[0]++, 28);
cov_vwwk9nd8u().s[1]++;
export var SnippetDefault = function SnippetDefault(_ref) {
  var message = _ref.message,
    linkText = _ref.linkText,
    classNameLink = _ref.classNameLink,
    additionalContent = _ref.additionalContent,
    onClick = _ref.onClick;
  cov_vwwk9nd8u().f[0]++;
  var _ref2 = (cov_vwwk9nd8u().s[2]++, useAppContext()),
    shouldInheritBg = _ref2.shouldInheritBg,
    loading = _ref2.loading,
    getExperiment = _ref2.getExperiment;
  var styleConfig = (cov_vwwk9nd8u().s[3]++, useStyleConfig());
  var borderLess = (cov_vwwk9nd8u().s[4]++, !styleConfig.hasBorder);
  var _ref3 = (cov_vwwk9nd8u().s[5]++, useState(false)),
    _ref4 = _slicedToArray(_ref3, 2),
    isSingleLine = _ref4[0],
    setSingleLine = _ref4[1];
  var contentRef = (cov_vwwk9nd8u().s[6]++, useRef(null));
  var isRamadanEnabled = (cov_vwwk9nd8u().s[7]++, getExperiment('CT2-836-ramadan-widgets') === 'test');
  cov_vwwk9nd8u().s[8]++;
  var handleSnippetClick = function handleSnippetClick() {
    cov_vwwk9nd8u().f[1]++;
    cov_vwwk9nd8u().s[9]++;
    if (!loading) {
      cov_vwwk9nd8u().b[0][0]++;
      cov_vwwk9nd8u().s[10]++;
      onClick();
    } else {
      cov_vwwk9nd8u().b[0][1]++;
    }
  };
  cov_vwwk9nd8u().s[11]++;
  useEffect(function () {
    cov_vwwk9nd8u().f[2]++;
    cov_vwwk9nd8u().s[12]++;
    if ((cov_vwwk9nd8u().b[2][0]++, !loading) && (cov_vwwk9nd8u().b[2][1]++, contentRef.current)) {
      cov_vwwk9nd8u().b[1][0]++;
      var contentHeight = (cov_vwwk9nd8u().s[13]++, contentRef.current.offsetHeight);
      cov_vwwk9nd8u().s[14]++;
      setSingleLine(contentHeight <= SINGLE_LINE_MAX_HEIGHT);
    } else {
      cov_vwwk9nd8u().b[1][1]++;
    }
  }, [contentRef, loading]);
  cov_vwwk9nd8u().s[15]++;
  return /*#__PURE__*/React.createElement(SnippetWrapper, {
    onClick: handleSnippetClick,
    className: cn(styles.snippetWrapper, (cov_vwwk9nd8u().b[3][0]++, borderLess) && (cov_vwwk9nd8u().b[3][1]++, styles.snippetWrapperBorderLess), shouldInheritBg ? (cov_vwwk9nd8u().b[4][0]++, null) : (cov_vwwk9nd8u().b[4][1]++, styles.snipperWrapperBgWhite), (cov_vwwk9nd8u().b[5][0]++, additionalContent) && (cov_vwwk9nd8u().b[5][1]++, styles.snippetAdditionalBlock))
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.snippetContentWrapper, (cov_vwwk9nd8u().b[6][0]++, loading) && (cov_vwwk9nd8u().b[6][1]++, styles.loading), (cov_vwwk9nd8u().b[7][0]++, borderLess) && (cov_vwwk9nd8u().b[7][1]++, styles.snippetContentBorderLess), (cov_vwwk9nd8u().b[8][0]++, isSingleLine) && (cov_vwwk9nd8u().b[8][1]++, !isRamadanEnabled) && (cov_vwwk9nd8u().b[8][2]++, styles.singleLine))
  }, loading ? (cov_vwwk9nd8u().b[9][0]++, /*#__PURE__*/React.createElement(Skeleton, null)) : (cov_vwwk9nd8u().b[9][1]++, /*#__PURE__*/React.createElement(SnippetContent, {
    message: message,
    link: linkText,
    classNameLink: cn(styles.snippetLink, classNameLink),
    ref: contentRef
  })), /*#__PURE__*/React.createElement(Logo, {
    className: styles.logo,
    color: isRamadanEnabled ? (cov_vwwk9nd8u().b[10][0]++, 'ramadan') : (cov_vwwk9nd8u().b[10][1]++, 'black on green')
  })), (cov_vwwk9nd8u().b[11][0]++, !loading) && (cov_vwwk9nd8u().b[11][1]++, additionalContent) && (cov_vwwk9nd8u().b[11][2]++, /*#__PURE__*/React.createElement("div", {
    className: styles.additionalContentWrapper
  }, additionalContent)));
};